module.exports = __webpack_public_path__ + "static/media/burger-builder.b8503d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/burger-builder.png
// module id = 69
// module chunks = 16